import {signal, computed} from '@preact/signals-core';
import type {AuthUser, PendingChallenge} from './auth.types.js';

export const userSignal = signal<AuthUser | null>(null);
export const isLoggedIn = computed(() => userSignal.value !== null);
export const authChecking = signal(true);
export const pendingChallengeSignal = signal<PendingChallenge | null>(null);
